import { BackgroundMedia } from '../page-components/background-media.model';
import { Map } from '../page-components/components/map.model';
import { Media } from '../page-components/media.model';
import { Padding } from '../page-components/padding.model';

export class Settings {
  Language: string = '';
  GoogleMaps: Map = new Map();
  Analytics: Analytics = new Analytics();
  Privacy: Privacy = new Privacy();
  PageName: string = '';
  Organization: Organization = new Organization();
  Turnstile: Turnstile = new Turnstile();
  Modules: ProjectModeules = new ProjectModeules();
  AuthTexts: AuthTexts = new AuthTexts();
}

export class Turnstile {
  UseTurnstile: boolean = false;
  SiteKey?: string;
  Mode?: string;
  Theme?: string;
  Language?: string;
}

export class Analytics {
  TagManagerId: string = '';
}

export class Privacy {
  ShowCookieConsent: boolean = false;
  CookieConsentText?: string;
  CookiePageUrl?: string;
  // Background: BackgroundMedia = new BackgroundMedia();
  // Padding?: Padding;

  CookieIconColor?: string;
  PrivacyPageUrl?: string;

  Necessary: string = '';
  NecessaryDescription: string = '';
  Functional: string = '';
  FunctionalDescription: string = '';
  Statistic: string = '';
  StatisticDescription: string = '';
  Marketing: string = '';
  MarketingDescription: string = '';

  OkButton: CookieButton = new CookieButton();
  UpdateButton: CookieButton = new CookieButton();

  Cookies: Cookie[] = [];

  CookieVersion: number = 0;
}

export class Cookie {
  Name: string = '';
  Type: number = 1;
  Description: string = '';
}

export class Organization {
  Name: string = '';
  Description: string = '';
  Logo: Media = new Media();
  Url: string = '';
  StreetAddress: string = '';
  AddressLocality: string = '';
  AddressRegion: string = '';
  PostalCode: string = '';
  AddressCountry: string = '';
  PhoneNumber: string = '';
  Email: string = '';
}

export class CookieButton {
  Text: string = '';
}

export class ProjectModeules {
  TimeBooking: boolean = false;
  Authentication: boolean = false;
}

export class AuthTexts {
  Login: string = 'Log in';
  CreateAccount: string = 'Create account';
  ForgotPassword: string = 'Forgot password?';
  ForgotPasswordHeader: string = 'Reset password';
  ForgotPasswordIntro: string =
    'Enter your email address and we will send a reset code if an account exists.';
  SendPasswordResetCode: string = 'Send reset code';
  PasswordResetEmailSent: string = 'Password reset email sent.';
  PasswordResetCodeIntro: string = 'Enter the 6 digit code from the email.';
  PasswordResetCode: string = 'Reset code';
  VerifyPasswordResetCode: string = 'Verify code';
  NewPassword: string = 'New password';
  ResetPassword: string = 'Reset password';
  PasswordReset: string = 'Your password has been reset.';
  BackToLogin: string = 'Back to log in';
  InvalidPasswordResetCode: string = 'The reset code is incorrect.';
  InvalidPasswordResetToken: string =
    'The reset token has expired. Request a new code and try again.';
  ValidateEmail: string = 'Validate email';
  ValidateEmailIntro: string =
    'Enter the 4 digit code from the validation email.';
  ValidationCode: string = 'Validation code';
  AccountMode: string = 'Account mode';
  Profile: string = 'Profile';
  LoadingProfile: string = 'Loading profile...';
  SignedInAs: string = 'Signed in as';
  EmailValidated: string = 'Email validated';
  EmailNotValidated: string = 'Email not validated';
  LogOut: string = 'Log out';
  ValidateEmailHeader: string = 'Validate your email';
  ValidateEmailText: string =
    'Validate your email address before booking so appointment messages can reach you.';
  ResendValidationEmail: string = 'Resend validation email';
  ProfileDetails: string = 'Profile details';
  FirstName: string = 'First name';
  LastName: string = 'Last name';
  Email: string = 'Email';
  Password: string = 'Password';
  EmailCannotBeChanged: string =
    'The email address cannot be changed afterwards.';
  MobilePhone: string = 'Mobile phone';
  SaveProfile: string = 'Save profile';
  BookedAppointments: string = 'Booked appointments';
  LoadingAppointments: string = 'Loading appointments...';
  Date: string = 'Date';
  Time: string = 'Time';
  Appointment: string = 'Appointment';
  Status: string = 'Status';
  Action: string = 'Action';
  Rebook: string = 'Rebook';
  Cancel: string = 'Cancel';
  NoBookedAppointments: string = 'No booked appointments yet.';
  Close: string = 'Close';
  KeepAppointment: string = 'Keep appointment';
  RebookAppointment: string = 'Rebook appointment';
  CancelAppointment: string = 'Cancel appointment';
  RebookReasonLabel: string = 'Reason for rebooking (optional)';
  CancelReasonLabel: string = 'Reason for cancellation (optional)';
  RebookReasonPlaceholder: string = 'Write a reason';
  CancelReasonPlaceholder: string = 'Write a reason';
  ProfileSaved: string = 'Profile saved.';
  AppointmentCancelled: string = 'Appointment cancelled.';
  ValidationEmailSent: string = 'Validation email sent.';
  RequestCouldNotBeCompleted: string = 'The request could not be completed.';
  InvalidLogin: string = 'Email or password is incorrect.';
  AccountExists: string = 'An account already exists for that email.';
  InvalidRequest: string = 'Check the details and try again.';
  InvalidValidationCode: string = 'The validation code is incorrect.';
  ValidatingEmail: string = 'Validating email';
  EmailValidationLinkInvalid: string = 'The email validation link is invalid.';
  EmailValidationRequestFailed: string =
    'The email validation request could not be completed.';
  AppointmentStatusConfirmed: string = 'Confirmed';
  AppointmentStatusBooked: string = 'Booked';
  AppointmentStatusBlocked: string = 'Blocked';
  AppointmentStatusCancelled: string = 'Cancelled';
}
